import Alpine from 'alpinejs';

export default function initHeader() {
  Alpine.data('header', () => ({
    opened: false,
    searchOpened: false,
    openSection: new Map<number, boolean>(),
    isSectionOpen(key: number) {
      return this.openSection.has(key) && this.openSection.get(key);
    },
    toggleSectionOpen(key: number) {
      this.openSection.set(key, this.openSection.has(key) ? !this.openSection.get(key) : true);
    },
    toggleOpen() {
      document.body.classList.toggle('menu-opened');
      this.opened = !this.opened;
    },
    toggleSearchOpen() {
      this.searchOpened = !this.searchOpened;
    },
    closeSearchOpen() {
      this.searchOpened = false;
    },
    init() {
      const elAutohide = document.getElementById('header') as HTMLElement;
      const mainWrapper = document.getElementById('wrapper') as HTMLElement;

      if (elAutohide) {
        let lastScrollTip = 0;
        window.addEventListener('scroll', () => {
          const scrollTop = window.scrollY;
          if (scrollTop === 0) {
            elAutohide.classList.add('scrolled-top');
            elAutohide.classList.remove('scrolled-down', 'scrolled-up');

            mainWrapper.classList.add('scrolled-top');
            mainWrapper.classList.remove('scrolled-down', 'scrolled-up');
          } else if (scrollTop < lastScrollTip) {
            elAutohide.classList.remove('scrolled-top', 'scrolled-down');
            elAutohide.classList.add('scrolled-up');

            mainWrapper.classList.remove('scrolled-top', 'scrolled-down');
            mainWrapper.classList.add('scrolled-up');
          } else {
            elAutohide.classList.remove('scrolled-top', 'scrolled-up');
            elAutohide.classList.add('scrolled-down');

            mainWrapper.classList.remove('scrolled-top', 'scrolled-up');
            mainWrapper.classList.add('scrolled-down');
          }
          lastScrollTip = scrollTop;
        });
      }
    },
  }));
}
